export function openSMSEditor (phone, message) {
  const smsLink =
      'sms:' + phone + '?body=' + encodeURIComponent(message)
  window.location.href = smsLink
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/sms-editor.js